export default function LeaseDetails() {
  return <div>Lease Details Page</div>;
}

